import { ReactNode } from "react";
import { HeroLayout, HeroLayoutMode } from "@kaltura/mediaspace-shared-layout";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";

interface MeetingRoomHeroLayoutProps {
    collapsedHero?: boolean;
    isAdvancedTemplateRoom?: boolean;
    children: ReactNode;
}

/**
 * Layout for active meeting room hero component (not for the room's lobby)
 */
export const MeetingRoomHeroLayout = ({
    collapsedHero,
    isAdvancedTemplateRoom,
    children,
}: MeetingRoomHeroLayoutProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <HeroLayout
            mode={
                (isMobile && !isAdvancedTemplateRoom) || collapsedHero
                    ? HeroLayoutMode.AspectRatio
                    : HeroLayoutMode.FullSize
            }
        >
            {children}
        </HeroLayout>
    );
};
